import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { PackagingExpeditionsBoxTab } from "@/components/backOffice/packaging/packagingExpeditionsBoxTab";
import { PackagingReadyTab } from "@/components/backOffice/packaging/packagingReadyTab";
import { PackagingShippedTab } from "@/components/backOffice/packaging/packagingShippedTab";
import {
  PACKAGING_TABS,
  type PackagingTab,
} from "@/components/backOffice/packaging/packagingStatusBox";

const TAB_PARAM = "packagingTab";
const DEFAULT_TAB: PackagingTab = "box";

export const PackagingPage = () => {
  const { t } = useTranslation("boLogistics");
  const [searchParams, setSearchParams] = useSearchParams();

  const rawTab = searchParams.get(TAB_PARAM) as PackagingTab | null;
  const tab = rawTab && PACKAGING_TABS.includes(rawTab) ? rawTab : DEFAULT_TAB;

  const setTab = useCallback(
    (next: PackagingTab) => {
      setSearchParams(
        (prev) => {
          const params = new URLSearchParams(prev);
          params.set(TAB_PARAM, next);
          return params;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );

  return (
    <div className="bg-border/20 flex h-fit min-h-dvh w-full flex-1 flex-col gap-4 p-4 sm:p-8">
      <div className="flex flex-col gap-2">
        <h1 className="font-jakarta-sans text-3xl font-semibold">{t("packagingPage.title")}</h1>
        <p className="text-gray-500">{t("packagingPage.subtitle")}</p>
      </div>
      {tab === "box" && <PackagingExpeditionsBoxTab tab={tab} onTabChange={setTab} />}
      {tab === "ready" && <PackagingReadyTab tab={tab} onTabChange={setTab} />}
      {tab === "shipped" && <PackagingShippedTab tab={tab} onTabChange={setTab} />}
    </div>
  );
};
